import { useState } from "react";
import { createContainer } from 'unstated-next';
import { INIT_INPUT_STD_VALUES, INIT_DOCUMENTS_VALUES } from "../config/common";

function useApplicant() {
    
    let [showInvalid, setShowInvalid] = useState({
      support_documents: ''
    });
    
    let [error, setError] = useState([]);
    let [validate, setValidate] = useState(false);    
    
    let [submissionID, setSubmissionID] = useState('');

    let [showOtherInfoHeader, setOtherInfoHeader] = useState("");

    let [showOtherInfoHeader2, setOtherInfoHeader2] = useState("");

    let [inStdValues, onChangeInStdValues] = useState(INIT_INPUT_STD_VALUES);
    
    let [documents, onChangeDocuments] = useState(INIT_DOCUMENTS_VALUES);

    let [showParentGuardian, setShowParentGuardian] = useState(0);

    let [inputHighestQualification, setInputHighestQualification] = useState(null);
    
    let [inputQualification, setInputQualification] = useState([
        { highest: true, qualification: '', grade: '' }
      ]);
    let [showQualification, setQualification] = useState(0);

    let [inputMusicBackground, setInputMusicBackground] = useState([
        { InstrumentPlayed: '', MusicGrade: '' }
      ]);      
    let [showMusicBackground, setShowMusicBackground] = useState(0);
    
    let [inputSports, setInputSports] = useState([
        { SportLevel: '', SportType: '', SportPeriod: '', SportRemark: '' }
      ]);      
    let [showSports, setShowSports] = useState(0);

    let [showEssay, setShowEssay] = useState(0);

    let [showContactReferee, setShowContactReferee] = useState(0);
    let [inputContactReferee, setInputContactReferee] = useState([
      { sname: '', affiliation: '', position: '', email: '' }
    ]);
    
    let [inputSiblings, setInputSiblings] = useState([
      {SiblingName: '', Gender: '', Age: '', Occupation: '', Income: '', NameOfSchool: '', SrcFinSupport: '' }
    ]);   
    let [showFamilyBackground, setShowFamilyBackground] = useState(0);
    let [showCommunityCC, setShowCommunityCC] = useState(0);
    
    let [inputSupportingDocuments, setInputSupportingDocuments] = useState([]);
    let [ShowSupportingDocuments, setShowSupportingDocuments] = useState(0);

    let [showScholarshipOffer, setScholarshipOffer] = useState(null);
    let [scholarshipChosen, setScholarshopChosen] = useState(null);

    let [showProgramme, setProgramme] = useState(0);
    let [showProgrammeOffer, setProgrammeOffer] = useState([]);
    let [programmmeChosen, setprogrammmeChosen] = useState('');
    let [showProgrammeOfferLoad, setProgrammeOfferLoad] = useState(false);
    let [showIntakesNoOffer, setIntakesNoOffer] = useState([]);
    let [intakeNoChosen, setIntakeNoChosen] = useState('');
    
    let [showExtracurricular, setShowExtracurricular] = useState(0);
    let [inputExtracurricularLeadership, setInputExtracurricularLeadership] = useState([{LeaderYear: '', LeaderName: '', LeaderPosition: ''}]);
    let [inputExtracurricularCompete, setInputExtracurricularCompete] = useState([{CompeteYear: '', CompeteName: '', CompeteResult: ''}]);
    let [inputExtracurricularAward, setInputExtracurricularAward] = useState([{  AwardYear: '', AwardName: '' }]);
    let [inputExtracurricularOther, setInputExtracurricularOther] = useState([{  AwardYear: '', AwardName: '' }]);

    let [showScholarshipType, setScholarshipType] = useState(0);

    let [showSchRegisterStatus, setShowSchRegisterStatus] = useState('');

    return { 
        showInvalid, setShowInvalid,

        showOtherInfoHeader, setOtherInfoHeader,
        showOtherInfoHeader2, setOtherInfoHeader2,

        inStdValues, onChangeInStdValues,
        documents, onChangeDocuments,

        showScholarshipOffer, setScholarshipOffer,
        scholarshipChosen, setScholarshopChosen,
        
        showProgramme, setProgramme,
        showProgrammeOffer, setProgrammeOffer,    
        showProgrammeOfferLoad, setProgrammeOfferLoad,    
        programmmeChosen, setprogrammmeChosen,
        showIntakesNoOffer, setIntakesNoOffer,
        intakeNoChosen, setIntakeNoChosen,
        
        showParentGuardian, setShowParentGuardian,

        showQualification, setQualification,
        inputQualification, setInputQualification,
        inputHighestQualification, setInputHighestQualification,
        
        inputMusicBackground, setInputMusicBackground,
        showMusicBackground, setShowMusicBackground,

        inputSports, setInputSports,
        showSports, setShowSports,

        showEssay, setShowEssay,

        showContactReferee, setShowContactReferee,
        inputContactReferee, setInputContactReferee,

        showExtracurricular, setShowExtracurricular,
        inputExtracurricularLeadership, setInputExtracurricularLeadership,
        inputExtracurricularCompete, setInputExtracurricularCompete,
        inputExtracurricularAward, setInputExtracurricularAward,
        inputExtracurricularOther, setInputExtracurricularOther,

        showFamilyBackground, setShowFamilyBackground,
        showCommunityCC, setShowCommunityCC,
        inputSiblings, setInputSiblings,

        ShowSupportingDocuments, setShowSupportingDocuments,
        inputSupportingDocuments, setInputSupportingDocuments,

        showScholarshipType, setScholarshipType,

        showSchRegisterStatus, setShowSchRegisterStatus,

        submissionID, setSubmissionID,

        error, setError,
        validate, setValidate
    } 
}
export const ApplicantContainer = createContainer(useApplicant)